import React from 'react';
import styles from '../../pages/ContactPage/ContactPage.module.scss';
import { ContactFormProps } from './types/ContactForm.types';

export const ContactForm: React.FC<ContactFormProps> = ({
  formData,
  errors,
  isLoading,
  isFormInvalid,
  error,
  t,
  handleChange,
  handleSubmit,
  descriptionKey,
  namePlaceholderKey,
  emailPlaceholderKey,
  thirdPlaceholderKey,
  thirdFieldName = 'message',
  thirdFieldType = 'textarea',
  buttonTextKey,
  buttonLoadingKey
}) => {
  const description = t(
    descriptionKey || 'landing.newsletterSubscription.description',
    'Novedades, talento y conocimiento. Suscríbete para conocer a nuestros profesionales destacados y recibir contenido de valor directamente en tu bandeja de entrada.'
  );

  const namePlaceholder = t(namePlaceholderKey || 'landing.newsletterSubscription.name', 'Tu nombre');
  const emailPlaceholder = t(emailPlaceholderKey || 'landing.newsletterSubscription.email', 'tunombre@email.com');
  const thirdPlaceholder = t(thirdPlaceholderKey || 'landing.newsletterSubscription.interest', 'Ej. medicina integrativa, bienestar, comunidad');

  const btnLoadingText = t(buttonLoadingKey || 'landing.newsletterSubscription.buttonLoading', 'Enviando...');
  const btnText = t(buttonTextKey || 'landing.newsletterSubscription.buttonText', 'Quiero empezar');

  return (
    <form className={styles['form']} onSubmit={handleSubmit} noValidate>
      <p className={styles['form__copy']}>
        {description}
      </p>

      <div className={styles['form__field-group']}>
        <input
          type="text"
          name="name"
          value={formData?.name || ''}
          onChange={handleChange}
          placeholder={namePlaceholder}
          className={`${styles['form__input']} ${errors?.name ? styles['form__input--error'] : ''}`}
          disabled={isLoading}
          required
        />
        {errors?.name && <span className={styles['form__error-text']}>{errors.name}</span>}
      </div>
      
      <div className={styles['form__field-group']}>
        <input
          type="email"
          name="email"
          value={formData?.email || ''}
          onChange={handleChange}
          placeholder={emailPlaceholder}
          className={`${styles['form__input']} ${errors?.email ? styles['form__input--error'] : ''}`}
          disabled={isLoading}
          required
        />
        {errors?.email && <span className={styles['form__error-text']}>{errors.email}</span>}
      </div>

      <div className={styles['form__field-group']}>
        {thirdFieldType === 'textarea' ? (
          <textarea
            name={thirdFieldName}
            value={formData?.[thirdFieldName] || ''}
            onChange={handleChange}
            placeholder={thirdPlaceholder}
            className={`${styles['form__input']} ${styles['form__input--textarea']} ${errors?.[thirdFieldName] ? styles['form__input--error'] : ''}`}
            disabled={isLoading}
            required
            rows={4}
          />
        ) : (
          <input
            type="text"
            name={thirdFieldName}
            value={formData?.[thirdFieldName] || ''}
            onChange={handleChange}
            placeholder={thirdPlaceholder}
            className={`${styles['form__input']} ${errors?.[thirdFieldName] ? styles['form__input--error'] : ''}`}
            disabled={isLoading}
            required
          />
        )}
        {errors?.[thirdFieldName] && <span className={styles['form__error-text']}>{errors[thirdFieldName]}</span>}
      </div>

      <button
        type="submit"
        className={styles['form__button']}
        disabled={isLoading}
      >
        {isLoading ? btnLoadingText : btnText}
      </button>

      {error && (
        <p className={styles['form__message--error']}>
          {error}
        </p>
      )}
    </form>
  );
};
